import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FiColorPalettePickerComponent } from './fi-color-palette-picker.component';
import { FormsModule } from '@angular/forms';

@NgModule({
    imports: [CommonModule, FormsModule],
    declarations: [FiColorPalettePickerComponent],
    exports: [FiColorPalettePickerComponent],
})
export class FiColorPalettePickerModule {}
